import { v4 as guid } from 'uuid'
type Layout = 'form' | 'popup' | 'fullscreen' | 'notification'
type UnsetPayload = {
  cid?: string
  layout: Layout
}
type SetPayload = {
  component: unknown
  props: unknown
} & UnsetPayload

export default {
  namespaced: true,
  state: (): State => {
    return {
      components: [],
    }
  },
  getters: {
    getComponents(state) {
      return state.components
    },
  },
  mutations: {
    SET_MODULE(state, payload: Required<SetPayload>) {
      state.components.push({
        cid: guid(),
        ...payload,
      })
    },
    UNSET_MODULE(state, payload: UnsetPayload) {
      state.components = state.components.filter((el) => {
        const key = payload.cid ? 'cid' : 'layout'
        return el[key] !== payload[key]
      })
    },
  },
}
